import React from "react";
import { Link } from "react-router-dom";
const Breadcrumb = ({ ...props }) => {
  function isLast(index) {
    return index === props.crumbs.length - 1;
  }
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {props.crumbs.map((crumb, ci) => {
          const disabled = isLast(ci) ? "disabled" : "";
          return isLast(ci) ? (
            <li
              className="breadcrumb-item active"
              key={ci}
              onClick={() => props.selected(crumb)}
            >
              {crumb}
            </li>
          ) : (
            <Link
              className={`breadcrumb-item ${disabled}`}
              aria-current="page"
              key={ci}
              to="/"
            >
              {crumb}
            </Link>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
